/*
 * File: POReceipt.tsx
 * Project: mdsi-template-app
 * -----
 * Last Modified: 11 Feb 2021 12:20:39 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Col, Row } from 'antd';
import { BlockLoader } from 'components/atoms/BlockLoader';
import { Breadcrumbs } from 'components/atoms/Breadcrumbs';
import { POReceiptDataDisiplay } from 'components/molecules/POReceiptDataDisplay';
import { ReceiptTable } from 'components/organisms/ReceiptTable';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setSelectedReceipt } from 'redux/poReceipts/po-receipts-slice';
import { useGetPurchaseOrderQuery } from 'redux/services/grannyBird/grannyBirdApi';
import { ReduxState } from 'redux/store';

const styles: InlineStylesModel = {
  errorMessage: {
    paddingTop: 15
  }
};

export const POReceipt = (): JSX.Element => {
  const dispatch = useDispatch();
  const { PoReceiptId } = useParams<{ PoReceiptId: string }>();
  const { selectedReceipt } = useSelector((state: ReduxState) => state.poReceipts);
  const { data: poReceipt, isLoading, isFetching } = useGetPurchaseOrderQuery({ purchaseOrderId: PoReceiptId });

  useEffect(() => {
    console.log(selectedReceipt, poReceipt);
    if (!selectedReceipt && poReceipt) {
      console.log('FIRE FIRE FIRE FIRE');
      dispatch(setSelectedReceipt(poReceipt));
    }
  }, [dispatch, poReceipt, selectedReceipt]);

  if (isLoading || isFetching)
    return (
      <Row justify="center" align="middle" style={{ width: '100%', height: '20vh' }}>
        <Col>
          <BlockLoader direction="loader loader--slideUp" />
        </Col>
      </Row>
    );

  const ErrorJSX = (
    <Row justify="center" style={styles.errorMessage}>
      <h1> We couldn&#8217;t find this Receipt&#8217;s line information ... Please refresh.</h1>
    </Row>
  );

  if (!poReceipt) return ErrorJSX;

  return (
    <Row>
      <Col span={24}>
        <Breadcrumbs poReceipt={poReceipt} />
      </Col>
      <Col span={24}>
        <POReceiptDataDisiplay poReceipt={poReceipt} />
      </Col>
      <Col style={{ marginTop: 16 }} span={24}>
        <ReceiptTable />
      </Col>
    </Row>
  );
};
